import { Directive, HostListener, Input, Optional } from '@angular/core';
import { CdkStepper, CdkStepperNext, CdkStepperPrevious } from '@angular/cdk/stepper';

import { McRAIStepper } from '../components/stepper';

@Directive({
  selector: '[mcraiStepperNext]',
  providers: [{ provide: CdkStepper, useExisting: McRAIStepper }]
})
export class StepperNextButtonDirective extends CdkStepperNext {
  constructor(
    @Optional() stepper: McRAIStepper
  ) {
    super(stepper);
  }

  @Input('mcraiStepperNext') _stepper: McRAIStepper;

  @HostListener('click')
  _onClick() {
    this._stepper.next();
  }
}

@Directive({
  selector: '[mcraiStepperPrev]',
  providers: [{ provide: CdkStepper, useExisting: McRAIStepper }]
})
export class StepperPrevButtonDirective extends CdkStepperPrevious {
  constructor(
    @Optional() stepper: McRAIStepper
  ) {
    super(stepper);
  }

  @Input('mcraiStepperPrev') _stepper: McRAIStepper;

  @HostListener('click')
  _onClick() {
    this._stepper.previous();
  }
}
